var render, staticRenderFns
import script from "./timeline-item.vue?vue&type=script&lang=js&"
export * from "./timeline-item.vue?vue&type=script&lang=js&"
import style0 from "./timeline.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "timeline-item.vue"
export default component.exports